import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import Adminnav from "../Adminnav";
import Cards from "../Cards";
import BaseURL from "../../Util/BaseURL";
const TotalProducts = () => {
  const [products, setProducts] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 4;
  const pagesVisited = pageNumber * productsPerPage;
  const [pageCount, setPageCount] = useState();

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const getProducts = async () => {
    const response = await axios.get(
      `${BaseURL}getAllProducts?size=${productsPerPage}&startPage=${pageNumber}`
    );
    setPageCount(Math.ceil(response.data.totalPages));
    setProducts(response.data.content);
  };
  useEffect(() => {
    getProducts();
  }, [pageNumber]);
  return (
    <>
      <Adminnav />
      <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 total h-100 w-100 mx-auto">
        {products ? products.map((data,key) => <Cards key={key} data={data} />) : ""}
      </div>
      <div className="totalpagebtn h-100 w-100">
        <ReactPaginate
          previousLabel={<i className="fas fa-angle-double-left"></i>}
          nextLabel={<i className="fas fa-angle-double-right"></i>}
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns"}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
        />
      </div>
    </>
  );
};

export default TotalProducts;
